/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GraphTopology } from './GraphTopology';

/**
 * A subagent patched onto the agent. The agent DECLARES the identity +
 * wiring (`name`/`role`/`spawn_mode`/`spawn_via`/`max_nesting_depth`/
 * `palette`); `subgraph` is DERIVED from the subagent's own compiled graph.
 *
 * `subgraph` is optional because not every subagent is graph-based (a
 * throwaway diagnostic stub has none) — the panel shows "no internal graph"
 * in that case rather than a fake one.
 */
export type SubagentDescriptor = {
  name: string;
  role: string;
  spawn_mode: SubagentDescriptor.spawn_mode;
  spawn_via?: string | null;
  max_nesting_depth?: number;
  palette?: Array<string>;
  subgraph?: GraphTopology | null;
};
export namespace SubagentDescriptor {
  export enum spawn_mode {
    TOOL = 'tool',
    NODE = 'node',
  }
}
